import { createAsyncThunk } from '@reduxjs/toolkit';
import sanityClient from '../../../lib/sanityClient';

export const fetchAlbums = createAsyncThunk(
    'albums/fetch',
    sanityClient.getAlbums
);
